import get from 'lodash.get';

export const selectUpdate = state => get(state, 'setup.update');
export const selectUpdateProgress = state => get(selectUpdate(state), 'progress');
export const selectIsSkipUpdate = state => get(selectUpdate(state), 'skip');
